// Services.jsx
import { FaBriefcase, FaChartLine } from 'react-icons/fa';
import { MdFamilyRestroom } from 'react-icons/md';

export const Services = () => {
  const services = [
    {
      title: "Entrepreneurial Growth Solutions",
      description: "Secure growth capital, structured financing and diversification opportunities for your businesses. Get assistance with SME IPOs, Mergers & Acquisitions or Business restructuring",
      icon: <FaBriefcase size={40} color="#34C759" />,
    },
    {
      title: "Investment Strategies",
      description: "We offer tailored AIF, PMS, High yield safe fixed return instruments and Mutual fund baskets designed to meet your unique financial goals and preferences. We also offer access to private placement opportunities for HNIs and UHNIs",
      icon: <FaChartLine size={40} color="#34C759" />,
    },
    {
      title: "Estate & Succession Planning",
      description: "Seamless estate planning to ensure smooth wealth transfer without legal challenges. Exclusive opportunities for strategic investments",
      icon: <MdFamilyRestroom size={40} color="#34C759" />,
    }
  ];
  
    return (
      <section id="services" className="py-20 bg-green-50 h-auto md:h-screen">
        <div className="max-w-7xl mx-auto px-4">
          <div className='grid md:grid-cols-[1fr_600px] md:gap-x-[20px] items-center justify-end'>
<div></div>
            <div className="md:self-end justify-end items-start text-end mb-12 px-2">
            <div className="mb-3">
              <span className="text-lg font-bold text-green-600">Our </span>
              <span className="text-lg font-bold ">Services</span>
            </div>
            <div className = "text-xl md:text-4xl font-bold text-green-900">From wealth creation and preservation to establishing an enduring legacy</div>
            </div>
          </div>
          <div className="grid md:grid-cols-3 gap-6 md:gap-8">
          {services.map((service, index) => (
            <div key={index} className="bg-white px-8 md:px-16 py-6 md:py-12 rounded-lg shadow-lg flex flex-col items-center transition-transform hover:translate-y-[-10px] duration-300">
              {service.icon}
              <h3 className="text-base text-center md:text-xl font-semibold mt-[20px] mb-[10px]">{service.title}</h3>
              {/* Adjusted margins */}
              <p className="text-xs md:text-base text-center text-gray-600">{service.description}</p>
            </div>
          ))}
        </div>
        </div>
      </section>
    );
  };